import { Box, Stack, Typography } from '@mui/material';

import FooterPage from './footerPage';
import HelloSection from 'src/components/helloSection/helloSection';
import NavBar from 'src/components/heroSection/navBar';
import WORKING_IMG from './../resources/images/working_img.png';
import { content } from 'src/common/lang/en-US';

const ComingSoon: React.FC = () => {
    return (
        <Stack>
            <NavBar />
            <HelloSection />
            <Box display="flex" flex="1" flexDirection="column" height="100vh">
                <Box
                    bgcolor="white"
                    display="flex"
                    flex="1"
                    flexDirection="column"
                    gap="2rem"
                    px={{ md: '3rem', xs: '2rem' }}
                    py="2rem"
                >
                    <Box>
                        <Typography
                            color="textBlack"
                            sx={{
                                typography: { lg: 'h1_Thin', md: 'h2_Thin', sm: 'h2_Thin', xs: 'h3_Thin' },
                            }}
                            textAlign="center"
                            width="100%"
                        >
                            {content.commingSoon.message}
                        </Typography>
                    </Box>
                    <Box display="flex" justifyContent="center">
                        <Box component="img" src={WORKING_IMG} />
                    </Box>
                </Box>
                <FooterPage />
            </Box>
        </Stack>
    );
};

export default ComingSoon;
